import { gql } from "@apollo/client";
import { IntegrationThirdParty } from "./companyIntegrationLimitation";

export const CREATE_THIRD_PARTY_INTEGRATIONS = gql`
mutation CreateThirdPartyIntegrations($domain: String!, $inputs: [CreateIntegrationInput!]!) {
  company {
		createThirdPartyIntegrations(domain: $domain, inputs: $inputs) {
			message
			code
			success
			updatedValues {
				third_party_id
				fk_company
				description
				integration_jwt
				integration_expiration
				fk_integration_type
				integrationType {
					integration_type_id
					integration_name
					description
					access_level
				}
				fk_integration_access
				integrationAccess {
					integration_access_id
					weight
					temp
					water
				}
			}
		}
  }
}
`

export interface CreateThirdPartyIntegrationsResponse {
	company: {
		createThirdPartyIntegrations: {
			message: string
			code: string
			success: boolean
			updatedValues?: IntegrationThirdParty[]
		}
	}
}

export interface CreateThirdPartyIntegrationsArgs {
	domain: string;
	inputs: {
		description?: string
		fk_integration_type: number
		integrationAccess?: {
			weight?: boolean
			temp?: boolean
			water?: boolean
		}
	}[]
}
